import { InputMsg } from "@/features/chat/components/InputMsg";
import { Room } from "@/features/chat/components/Room";
import { RoomHead } from "@/features/chat/components/RoomHead";
import { CHAT_BOX_WIDTH } from "@/features/chat/constants/chat";
import { styled } from "@mui/material";
import React, { useRef, FC } from "react";

type TChatBoxProps = {
  open: boolean;
  chatBoxRef?: React.Ref<HTMLDivElement>;
};

export const ChatBox: FC<TChatBoxProps> = ({ open = false }) => {
  const chatBoxRef = useRef<HTMLDivElement>(null);
  const roomHeadRef = useRef<HTMLDivElement>(null);
  return (
    <ChatBoxWrapper ref={chatBoxRef} open={open}>
      {!!open && (
        <>
          <RoomHead ref={roomHeadRef} />
          <Room />
          <InputMsg chatBoxRef={chatBoxRef} roomHeadRef={roomHeadRef} />
        </>
      )}
    </ChatBoxWrapper>
  );
};

const ChatBoxWrapper = styled("div")<{ open: boolean }>`
  transition: all 0.2s ease;
  transform: ${({ open }) => (open ? "translateY(0)" : "translateY(10%)")};
  opacity: ${({ open }) => (open ? 1 : 0)};
  visibility: ${({ open }) => (open ? "visible" : "hidden")};
  position: absolute;
  bottom: 80px;
  right: 0;
  background-color: white;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  width: ${CHAT_BOX_WIDTH}px;
  height: calc(75vh - 96px);
  --chatbox-height: calc(75vh - 96px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: white;
`;
